import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg width="16" height="22" viewBox="0 0 16 22" xmlns="http://www.w3.org/2000/svg">
    <path
      id="&#244;&#128;&#139;&#166;"
      d="M0.96875 12.2228C0.96875 12.0105 1.05561 11.7917 1.22933 11.5665L10.2533 0.419347C10.427 0.200585 10.6136 0.0686847 10.813 0.0236456C11.0125 -0.0213936 11.1926 -0.00209111 11.3535 0.0815531C11.5143 0.165197 11.6269 0.303532 11.6913 0.496557C11.7556 0.683148 11.7363 0.905126 11.6334 1.16249L8.6994 9.07652H14.2875C14.5062 9.07652 14.6832 9.14408 14.8183 9.27919C14.9598 9.40788 15.0306 9.57517 15.0306 9.78106C15.0306 9.99339 14.9438 10.2089 14.77 10.4277L5.74612 21.5845C5.5724 21.7969 5.3858 21.9255 5.18635 21.9706C4.98689 22.0221 4.80673 22.006 4.64588 21.9223C4.48502 21.8387 4.37242 21.7004 4.30808 21.5073C4.24374 21.3207 4.26304 21.0955 4.36599 20.8317L7.29997 12.9177H1.7119C1.49313 12.9177 1.31298 12.8534 1.17143 12.7247C1.03631 12.5896 0.96875 12.4223 0.96875 12.2228Z"
    />
  </svg>
`;

export const Bolt = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
